import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {fromLonLat} from 'ol/proj';
import {Observable} from 'rxjs';
import OSM from 'ol/source/OSM';
import VectorLayer from 'ol/layer/Vector';
import TileLayer from 'ol/layer/Tile';
import VectorSource from 'ol/source/Vector';
import {Extent, Feature, Map, Overlay, View} from 'ol';
import {Fill, Stroke, Style} from 'ol/style';
import {Circle} from 'ol/geom';
import {UserTrackingService} from '@rsp/shared/services/user-tracking.service';

@Component({
  selector: 'rsp-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})

export class MapComponent implements OnInit, AfterViewInit {

  private map: Map;

  @Input() public regions: number[] = [];
  @Input() public markers: Array<number[]> = [];
  @Input() public mappoints: Array<number[]> = [];

  @Input() public mapRadiusKm = 25;

  @ViewChild('map', {static: true})
  private mapElement: ElementRef;

  constructor(private userTracker: UserTrackingService) {

  }

  ngOnInit(): void {
    this.map = this.createMap(this.mapElement.nativeElement);

  }

  ngAfterViewInit(): void {
    this.map.on('moveend', () => {
      this.userTracker.trackEvent('Karte', 'Verschoben');
    });
  }


  /**
   * Finds the provided region in static MARKERS and adds markers to the map
   *
   * @param region
   * @param map
   */
  public updateMap() {

    let target: any;

    for (const marker of this.markers) {
      target = fromLonLat(marker);

      const img = document.createElement('embed');
      img.setAttribute('src', '/assets/images/marker_' + target[2] + '.png');
      img.setAttribute('style', 'width: 36px; height: 50px;');

      this.map.addOverlay(new Overlay({
        offset: [-18, -50],
        position: target,
        stopEvent: false,
        element: img
      }));

    }


    for (let marker of this.mappoints) {
      marker = [+marker[0], +marker[1], marker[2]];
      target = fromLonLat(marker);

      if (target[2] !== 'usw') {
        continue;
      }

      const img = document.createElement('embed');
      img.setAttribute('src', '/assets/images/pin_' + target[2] + '.png');

      this.map.addOverlay(new Overlay({
        offset: [-10, -10],
        position: target,
        stopEvent: false,
        element: img
      }));

    }


    const geometry = this.map.getLayers().getArray()[1].getSource().getFeatures()[0].getGeometry();
    const circleSource: VectorSource = new VectorSource();
    const lineSource: VectorSource = new VectorSource();
    const extent: Extent = geometry.getExtent();

    const style: Style = new Style({
      fill: new Fill({
        color: 'rgba(34, 112, 147, 1)'
      }),
      stroke: new Stroke({
        width: 1,
        color: 'rgba(255, 50, 85, 1)'
      }),
      zIndex: 100
    });


    // for (let marker of MapService.MAPPOINTS) {
    // 	let point = fromLonLat([+marker['longitude'], +marker['latitude']]);  //correct?
    // 	console.log(point);
    //
    // 	let closest = circleSource.getClosestFeatureToCoordinate(point);
    // 	if (closest) {
    // 		lineSource.addFeature(new Feature(new LineString([point, closest.getGeometry().getCenter()])));
    // 	}
    // 	circleSource.addFeature(new Feature(new Circle(point, 50)));
    // }


    // for (let i = 0, l = Math.floor(Math.random() * 150) + 150; i < l; i++) {
    //
    // 	let fits: boolean = false;
    //
    // 	while (!fits) {
    //
    // 		const point: any[] = target || [
    // 			Math.random() * (extent[2] - extent[0]) + extent[0],
    // 			Math.random() * (extent[3] - extent[1]) + extent[1]
    // 		];
    //
    // 		if (geometry.intersectsCoordinate(point)) {
    //
    // 			let closest = circleSource.getClosestFeatureToCoordinate(point);
    // 			if (closest) {
    //
    // 				lineSource.addFeature(new Feature(new LineString([point, closest.getGeometry().getCenter()])));
    //
    // 			}
    //
    // 			circleSource.addFeature(new Feature(new Circle(point, 200)));
    //
    // 			target = null;
    // 			fits = true;
    //
    // 		}
    //
    // 	}
    //
    // }

    this.map.addLayer(new VectorLayer({
      source: circleSource,
      minResolution: 13,
      style: style
    }));

    this.map.addLayer(new VectorLayer({
      source: lineSource,
      minResolution: 13,
      style: style
    }));

  }

  /**
   * Receives a native HTMLElement, creates a osm map and fetches/renders the configured geojson data
   *
   * @param mapElement
   */
  public createMap(mapElement: HTMLElement): Observable<any> {

    /*
     * Create a new vector source and set the format to geojson
     * Provide the input/output projection to the geojson format
     */
    const vectorSource: VectorSource = new VectorSource({
      features: [
        new Feature(
          new Circle(fromLonLat(this.regions), this.mapRadiusKm ? this.mapRadiusKm * 1000 : 25900)
        )
      ]
    });

    /*
     * Create a new map object, remove all controls and interactions
     * Provide a tile layer (actual map) and load the tiles from osm
     * Provide a vector layer with custom styling and set the vector source
     */
    const map: Map = new Map({
      controls: [],
      // interactions: [],
      target: mapElement,
      layers: [
        new TileLayer({
          source: new OSM()
        }),
        new VectorLayer({
          style: new Style({
            fill: new Fill({
              color: 'rgba(52, 172, 224, 0.2)'
            })
          }),
          source: vectorSource
        }),
        new VectorLayer({
          style: new Style({
            fill: new Fill({
              color: 'rgba(52, 172, 224, 0.1)'
            }),
            stroke: new Stroke({
              color: 'rgba(52, 172, 224, 1)',
              width: 2
            }),
            zIndex: 101
          })
        })
      ],
      view: new View({
        center: [0, 0],
        zoomFactor: 1.4
      })
    });




    setTimeout(() => {

      map.getView().fit(vectorSource.getExtent(), map.getSize());

      map.once('precompose', () => {
        // TODO PS: einbauen
        // this.addMarkers(this.TARGET, map);
        this.updateMap();
        map.updateSize();

      });

    });

    return map;
  }




}
